/* SilkPearl cart — AJAX add, drawer, line quantity, gift note, upsell */
(function () {
  'use strict';

  var SECTION = 'sp-cart-drawer';
  var lastFocus = null;

  /* ---------- fly to bag ----------
     A cloned image arcs from the product to the bag icon. Purely decorative:
     it never gates the add, never delays the fetch, and is skipped entirely
     for reduced-motion or when either end cannot be located.

     Exposed on window because the PDP bundle add lives in sp-product.js while
     the bag icon and the drawer live here. One implementation, two callers. */
  /* TODO(unresolved, 25 Aug 2026): the client reports this still does not
     appear, after the off-screen-origin fix below. Verified working in code —
     flyToBag IS called with a valid image, .sp-icon--cart resolves, z-index 200
     sits above the drawer's 100 — so the failure is visual, not logical.
     NOT REPRODUCIBLE FROM HERE: the browser pane reports visibilityState
     "hidden", which pauses Web Animations, so this cannot be observed. Needs a
     screen recording from a real browser, or drop the feature. Do not "fix" it
     again without a way to see it. */
  function flyToBag(sourceImg, originEl) {
    var ghost = null;
    var cleanup = function () {
      if (ghost && ghost.parentNode) ghost.parentNode.removeChild(ghost);
      ghost = null;
    };
    try {
      if (!sourceImg || !sourceImg.getBoundingClientRect) return;
      if (window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
      if (typeof Element.prototype.animate !== 'function') return;
      /* Animations are paused in a hidden document, so onfinish would never
         fire and the ghost would sit on the page until the tab came back. */
      if (document.hidden) return;

      var target = document.querySelector('.sp-icon--cart');
      if (!target) return;
      var to = target.getBoundingClientRect();
      if (!to.width) return;

      var from = sourceImg.getBoundingClientRect();
      if (!from.width) return;

      /* On a product page you scroll past the gallery to reach Add to bag, so
         the image is usually ABOVE the viewport by the time it is clicked and
         the flight would start off-screen — which looked like nothing
         happening at all. When that is the case, start from whatever the
         shopper is actually looking at (the button) and shrink the ghost to a
         chip, keeping the product image as the thing that flies. */
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = from.bottom > 8 && from.top < vh - 8;
      if (!visible) {
        var anchor = (originEl && originEl.getBoundingClientRect)
          ? originEl.getBoundingClientRect()
          : { left: to.left, top: vh * 0.6, width: 0, height: 0 };
        var size = 132;
        from = {
          left: anchor.left + anchor.width / 2 - size / 2,
          top: anchor.top + anchor.height / 2 - size / 2,
          width: size,
          height: size
        };
      }

      ghost = sourceImg.cloneNode(true);
      ghost.removeAttribute('id');
      ghost.setAttribute('aria-hidden', 'true');
      ghost.style.cssText =
        'position:fixed;z-index:200;pointer-events:none;margin:0;border-radius:14px;' +
        'object-fit:cover;left:' + from.left + 'px;top:' + from.top + 'px;' +
        'width:' + from.width + 'px;height:' + from.height + 'px;';
      document.body.appendChild(ghost);

      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

      var run = ghost.animate(
        [
          { transform: 'translate(0,0) scale(1)', opacity: 1 },
          { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.35 - 60) + 'px) scale(.55)', opacity: .95, offset: .55 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0 }
        ],
        { duration: 760, easing: 'cubic-bezier(.4,.05,.35,1)' }
      );

      /* Belt and braces: onfinish is the normal path, the timer guarantees the
         ghost cannot outlive the animation if it is paused, cancelled or the
         tab is hidden mid-flight. Two ghosts were found stuck on a page during
         testing for exactly that reason. */
      run.onfinish = function () {
        cleanup();
        document.querySelectorAll('[data-sp-cart-count]').forEach(function (el) {
          el.animate(
            [{ transform: 'scale(1)' }, { transform: 'scale(1.45)' }, { transform: 'scale(1)' }],
            { duration: 360, easing: 'ease-out' }
          );
        });
      };
      run.oncancel = cleanup;
      window.setTimeout(cleanup, 2000);
    } catch (e) {
      cleanup(); /* decoration must never break an add, or litter the page */
    }
  }

  window.SilkPearl = window.SilkPearl || {};
  window.SilkPearl.flyToBag = flyToBag;

  /* The drawer markup is replaced wholesale on every cart change, so never
     cache element references — look them up each time. */
  function drawer() { return document.getElementById('sp-cart-drawer'); }
  function scrim() { return document.querySelector('.sp-cd-scrim'); }
  function root() { return document.getElementById('shopify-section-' + SECTION); }

  /* ---------- open / close ---------- */
  function setDrawer(open) {
    var d = drawer(), s = scrim();
    if (!d || !s) return;
    if (open) {
      lastFocus = document.activeElement;
      d.hidden = false;
      s.hidden = false;
      void d.offsetWidth; // force reflow; rAF is paused in background tabs
      d.classList.add('is-open');
      s.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var close = d.querySelector('[data-sp-cart-close]');
      if (close) close.focus();
    } else {
      d.classList.remove('is-open');
      s.classList.remove('is-open');
      document.body.style.overflow = '';
      window.setTimeout(function () {
        var dd = drawer(), ss = scrim();
        if (dd) dd.hidden = true;
        if (ss) ss.hidden = true;
      }, 380);
      if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    }
  }

  function isOpen() {
    var d = drawer();
    return !!d && d.classList.contains('is-open');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-sp-cart-close]')) setDrawer(false);
  });

  document.addEventListener('keydown', function (e) {
    var d = drawer();
    if (!d || d.hidden) return;
    if (e.key === 'Escape') { setDrawer(false); return; }
    if (e.key !== 'Tab') return;
    var f = d.querySelectorAll('a[href],button:not([disabled]),input,select,textarea');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- refresh ---------- */
  function updateCount(n) {
    document.querySelectorAll('[data-sp-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function refresh() {
    var open = isOpen();
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var jobs = [
      fetch(base + '?sections=' + SECTION)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var host = root();
          var html = data && data[SECTION];
          if (!host || !html) return;
          /* Was the order already qualifying before this re-render? Compare
             before replacing the markup, so the flourish fires on the flip
             and not on every quantity nudge afterwards. */
          var wasQualified = !!host.querySelector('[data-sp-ship].is-qualified');

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('shopify-section-' + SECTION) || doc.body;
          host.innerHTML = fresh.innerHTML;

          var ship = host.querySelector('[data-sp-ship].is-qualified');
          if (ship && !wasQualified) {
            ship.classList.add('is-just-qualified');
            window.setTimeout(function () { ship.classList.remove('is-just-qualified'); }, 700);
          }
          if (open) {
            var d = drawer(), s = scrim();
            if (d && s) {
              d.hidden = false; s.hidden = false;
              void d.offsetWidth;
              d.classList.add('is-open');
              s.classList.add('is-open');
            }
          }
        }),
      fetch(base + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { updateCount(cart.item_count); })
    ];

    // the cart page renders its own copy of the lines
    if (document.querySelector('[data-sp-cart-root]')) {
      jobs.push(
        fetch(base + 'cart', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var next = doc.querySelector('[data-sp-cart-root]');
            var here = document.querySelector('[data-sp-cart-root]');
            if (next && here) here.innerHTML = next.innerHTML;
          })
      );
    }

    return Promise.all(jobs);
  }

  /* ---------- add to cart ---------- */
  function addToCart(id, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: Number(quantity) || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  var form = document.getElementById('sp-product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      /* When the bundle widget is on the page it owns the whole submit — it
         adds several lines at once (masks, $0 gifts) and may attach a
         discount code. Both handlers running would double-add. */
      if (document.querySelector('[data-sp-bundle]')) return;
      var btn = form.querySelector('[data-sp-add]');
      var label = form.querySelector('[data-sp-add-label]');
      var previous = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      /* Capture the shot BEFORE the add: refresh() re-renders the drawer and
         opening it shifts layout, so a rect read afterwards is wrong. */
      var shot = document.querySelector('.sp-pdp__slide.is-active .sp-pdp__img, .sp-pdp__img');
      addToCart(form.querySelector('[data-sp-variant-id]').value, form.querySelector('[name="quantity"]').value)
        .then(function (r) { flyToBag(shot, btn); return r; })
        .then(refresh)
        .then(function () {
          if (label) label.textContent = previous || 'Add to bag';
          if (btn) btn.disabled = false;
          setDrawer(true);
        })
        .catch(function (err) {
          if (label) label.textContent = (err && err.description) ? 'Unavailable' : 'Could not add';
          window.setTimeout(function () {
            if (label) label.textContent = previous || 'Add to bag';
            if (btn) btn.disabled = false;
          }, 2400);
        });
    });
  }

  /* ---------- quick add (cards, drawer upsell, cart-page upsell) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sp-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-sp-quick-add');
    if (!id) return;
    var previous = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    /* The card's own image is the thing that should fly, and it must be
       measured before refresh() re-renders anything around it. */
    var card = btn.closest('.sp-card, .sp-up, [data-sp-card]');
    var shot = card ? card.querySelector('img') : null;

    addToCart(id, 1)
      .then(function (r) { flyToBag(shot, btn); return r; })
      .then(refresh)
      .then(function () { setDrawer(true); })
      .catch(function () {
        btn.textContent = 'Could not add';
        window.setTimeout(function () { btn.textContent = previous; btn.disabled = false; }, 2400);
      });
  });

  /* ---------- line quantity + removal ---------- */
  function change(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(refresh);
  }

  document.addEventListener('click', function (e) {
    var qtyBtn = e.target.closest('[data-sp-line-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-sp-line]');
      var countEl = line && line.querySelector('[data-sp-line-count]');
      var current = countEl ? parseInt(countEl.textContent, 10) : 1;
      var next = current + parseInt(qtyBtn.getAttribute('data-delta'), 10);
      if (next < 0) next = 0;
      change(qtyBtn.getAttribute('data-sp-line-qty'), next);
      return;
    }
    var removeBtn = e.target.closest('[data-sp-line-remove]');
    if (removeBtn) change(removeBtn.getAttribute('data-sp-line-remove'), 0);
  });

  /* ---------- gift note ---------- */
  function saveNote(note) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    });
  }

  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-sp-gift-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('.sp-gift');
    var field = wrap && wrap.querySelector('[data-sp-gift-note]');
    if (!field) return;
    field.hidden = !toggle.checked;
    if (toggle.checked) field.focus();
    else if (field.value) { field.value = ''; saveNote(''); }
  });

  document.addEventListener('blur', function (e) {
    var field = e.target.closest && e.target.closest('[data-sp-gift-note]');
    if (!field) return;
    saveNote(field.value);
  }, true);

  /* ---------- card colour swatches ---------- */
  /* Delegated: cards are re-rendered by the Section Rendering API on filter
     and pagination, so nothing here may hold a DOM reference. The committed
     image is snapshotted in a WeakMap so hover previews can be undone without
     writing scratch state onto the DOM. */
  var committed = new WeakMap();

  function cardMainImage(card) {
    return card.querySelector('.sp-card__img:not(.sp-card__img--alt)');
  }

  function applyImage(card, src, srcset) {
    var img = cardMainImage(card);
    if (!img || !src) return false;
    img.setAttribute('srcset', srcset || '');
    img.setAttribute('src', src);
    return true;
  }

  function previewImage(card, src, srcset) {
    var img = cardMainImage(card);
    if (!img || !src) return;
    if (!committed.has(card)) {
      committed.set(card, { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '' });
    }
    applyImage(card, src, srcset);
  }

  function restoreImage(card) {
    var snap = committed.get(card);
    if (!snap) return;
    applyImage(card, snap.src, snap.srcset);
    committed['delete'](card);
  }

  /* On a variant card the swatch is a link to that colour. If its card is on
     this page, jump to it instead of leaving for the product page. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-sp-swatch-link]');
    if (!link) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var id = link.getAttribute('data-variant');
    if (!id) return;
    var target = document.getElementById('sp-card-' + id);
    if (!target) return; /* not on this page — follow the href */
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.classList.add('is-jumped');
    window.setTimeout(function () { target.classList.remove('is-jumped'); }, 1200);
  });

  /* hover preview — mouse only. Touch fires a compatibility pointerover just
     before click, which would leave the preview stuck with nothing to undo it. */
  function hoverCapable() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    if (!hoverCapable()) return;
    var sw = e.target.closest && e.target.closest('[data-sp-swatch]');
    if (!sw) return;
    var card = sw.closest('.sp-card');
    if (!card) return;
    previewImage(card, sw.getAttribute('data-img'), sw.getAttribute('data-srcset'));
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var group = e.target.closest && e.target.closest('.sp-card__swatches');
    if (!group) return;
    /* moving between swatches inside the same row is not a leave */
    if (e.relatedTarget && group.contains(e.relatedTarget)) return;
    var card = group.closest('.sp-card');
    if (card) restoreImage(card);
  });

  /* click commits the colour */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sp-swatch]');
    if (!sw) return;
    e.preventDefault();

    var card = sw.closest('.sp-card');
    if (!card) return;

    if (applyImage(card, sw.getAttribute('data-img'), sw.getAttribute('data-srcset'))) {
      /* this is the new baseline — a later pointerout must not undo it */
      committed['delete'](card);
      /* the hover crossfade would flash the previous colour — stand it down
         once the shopper has picked one */
      var media = card.querySelector('.sp-card__media');
      if (media) media.classList.add('is-locked');
    }

    var group = sw.closest('.sp-card__swatches');
    if (group) {
      [].forEach.call(group.querySelectorAll('[data-sp-swatch]'), function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
    }
    sw.classList.add('is-active');
    sw.setAttribute('aria-pressed', 'true');

    /* carry the choice through to the product page and to quick add */
    var vid = sw.getAttribute('data-variant');
    if (!vid) return;
    var link = card.querySelector('.sp-card__frame');
    if (link) {
      link.setAttribute('href', link.getAttribute('href').split('?')[0] + '?variant=' + vid);
    }
    var qa = card.querySelector('[data-sp-quick-add]');
    if (qa) qa.setAttribute('data-sp-quick-add', vid);
  });

  /* keyboard focus previews too, and blur undoes it */
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('[data-sp-swatch]');
    if (!sw) return;
    var card = sw.closest('.sp-card');
    if (card) previewImage(card, sw.getAttribute('data-img'), sw.getAttribute('data-srcset'));
  });

  document.addEventListener('focusout', function (e) {
    var group = e.target.closest && e.target.closest('.sp-card__swatches');
    if (!group) return;
    if (e.relatedTarget && group.contains(e.relatedTarget)) return;
    var card = group.closest('.sp-card');
    if (card) restoreImage(card);
  });

  /* ---------- bundle adds ----------
     sp-product.js posts several lines at once, then fires this so the drawer
     opens with the gifts already in it. */
  document.addEventListener('sp:cart:changed', function () {
    refresh().then(function () { setDrawer(true); });
  });

  /* ---------- open from the header cart icon ---------- */
  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.sp-icon--cart');
    if (!cartLink || !drawer()) return;
    e.preventDefault();
    refresh().then(function () { setDrawer(true); });
  });
})();
